export default "__VITE_ASSET__836cbecf__"